import {FC} from 'react';
import {FlagOrb} from '../CountryDropdown/FlagOrb/FlagOrb';
import type {SelectedBank} from '../../../model';

type Props = {
	bank: Pick<SelectedBank, 'shortName' | 'iconUrl'>;
	className?: string;
};

export const BankIcon: FC<Props> = ({bank, className}) => {
	if (bank.iconUrl) {
		return <FlagOrb src={bank.iconUrl} alt="" className={className} />;
	}

	return <FlagOrb placeholder="union" tone="muted" className={className} />;
};
